<template>
    <div class="px-4 py-2">
        <h2>Alertas</h2>
        <b-row class="justify-content-center">
            <b-col xl="9" cols="12">
                <alert-recent />
                <alert-prev class="mt-3" />
            </b-col>
        </b-row>
        <alert-details />
    </div>
</template>

<script>
import AlertPrev from "./components/AlertPrev";
import AlertRecent from "./components/AlertRecent";
import AlertDetails from "./components/AlertDetails";

export default {
    name: "ViewAlerts",
    components: {
        AlertPrev,
        AlertRecent,
        AlertDetails
    }
};
</script>
